import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Page.css'; // Import your CSS file for styling
import smartStandLogo from './images/smart-stand-logo.png';
// import Logo from './images/website-logo.jpg'
import axiosInstance from '../axiosConfig';
import { isSmartCard } from '../smart/model';
import {QR_TYPE_GOOGLE_REVIEW}  from '../constants';
import { styled } from '@mui/material/styles';
import AppTheme from './shared-theme/AppTheme';
import Stack from '@mui/material/Stack';
import ColorModeSelect from './shared-theme/ColorModeSelect';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MuiCard from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Divider, { dividerClasses } from '@mui/material/Divider';

function HomePage(props) {
  const [qrCodeId, setQrCodeId] = useState('');
  const [qrType, setQrType] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
        maxWidth: '450px',
    },
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
        boxShadow:
        'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
}));

  const HomeContainer = styled(Stack)(({ theme }) => ({
    height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
    minHeight: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
    },
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        zIndex: -1,
        inset: 0,
        backgroundImage:
        'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
        backgroundRepeat: 'no-repeat',
        ...theme.applyStyles('dark', {
        backgroundImage:
            'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
        }),
    },
}));

  useEffect(() => {
    // Extract qrCodeId from query parameters
    const qrCodeIdFromParams = searchParams.get('id');
    const qrTypeFromParams = searchParams.get('t');
    if (qrCodeIdFromParams) {
        setQrCodeId(qrCodeIdFromParams);
    }
    if (qrTypeFromParams) {
        setQrType(qrTypeFromParams)
    }
    const checkSession = async () => {
      try {
        const response = await axiosInstance.get('/auth/check-session');
        console.log('response from check-session', response)
        if (response.data.userId && isSmartCard(qrCodeIdFromParams, qrTypeFromParams)) {
            navigate(`/studio/activate?id=${encodeURIComponent(qrCodeIdFromParams)}`);
        } else if (response.data.userId && qrCodeIdFromParams && qrTypeFromParams === QR_TYPE_GOOGLE_REVIEW) {
            navigate(`/google-review-config?id=${qrCodeId}&t=${qrType}`); 
        }
      } catch (error) {
        console.error('Error checking session:', error);
      }
    };
    checkSession();
  }, [navigate, searchParams, qrCodeId, qrType]); // Include navigate in the dependency array


  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <HomeContainer>
        <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} />
        <Card variant="outlined">
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                borderColor: 'divider',
                borderRadius: 1,
                color: 'text.secondary',
                [`& .${dividerClasses.root}`]: {
                mx: 1,
                },
            }}
            >
                <img 
                    src={smartStandLogo} 
                    alt="Smart Stand Logo" 
                    style={{ 
                        width: 36,
                        height: 36,
                        marginRight: 0 
                    }}
                />
                <Divider orientation="vertical" flexItem />
            <Typography
                variant="h4"
                sx={{ fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
            >
                Smart Stand
          </Typography>
        </Box>
        <Typography variant="body2" gutterBottom sx={{ display: 'block', fontSize: 'clamp(1.1rem, 1.75vw, 1.3rem)' }}>
                Empower your business with smart stand!
        </Typography>
        
        <Link
            href={`/login?id=${qrCodeId}&t=${qrType}`}
            variant="body2"
            sx={{ display: { xs: 'flex', md: 'flex' }, fontSize: 'clamp(1.5rem, 2.5vw, 1.75rem)' }}
        >
            Login
        </Link>
        <Link
            href={`/signup?id=${qrCodeId}&t=${qrType}`}
            variant="body2"
            sx={{ display: { xs: 'flex', md: 'flex' }, fontSize: 'clamp(1.5rem, 2.5vw, 1.75rem)'}}
        >
            Sign up
        </Link>
        </Card>
      </HomeContainer>
    </AppTheme>
  );
}

export default HomePage;
